import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AuthService } from 'src/app/services/auth.service';
import { CardItem } from './page-activity-card-item/page-activity-card-item.component';

@Component({
  selector: 'app-page-activity-needs-vs-wants-rw',
  templateUrl: './page-activity-needs-vs-wants-rw.component.html',
  styleUrls: ['./page-activity-needs-vs-wants-rw.component.css','../module-page-rw/module-page-rw.component.css']
})
export class PageActivityNeedsVsWantsRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  flag = false;

  model = {
    priorityList: {
      item1: { value: '' },
      item2: { value: '' },
      item3: { value: '' },
      item4: { value: '' },
      item5: { value: '' },
      item6: { value: '' },
      item7: { value: '' },
      item8: { value: '' },
      item9: { value: '' },
      item10: { value: '' },
      item11: { value: '' },
      item12: { value: '' },
      item13: { value: '' },
      item14: { value: '' },
      item15: { value: '' },
      item16: { value: '' },
      item17: { value: '' },
      item18: { value: '' },
      item19: { value: '' },
      item20: { value: '' },
    },
    cards: {
      pool: <CardItem[]>[
        { name: 'milk' },
        { name: 'vegetables' },
        { name: 'rent' },
        { name: 'school supplies' },
        { name: 'winter coat' },
        { name: 'vitamins' },
        { name: 'prescriptions' },
        { name: 'electricity bill' },
        { name: 'car insurance' },
        { name: 'DVD/VCR' },
        { name: 'eating out' },
        { name: 'cable' },
        { name: 'movies' },
        { name: 'a fourth pair of jeans' },
        { name: 'cigarettes' },
        { name: 'alcohol' },
        { name: 'lottery tickets' },
        { name: 'frozen dinner' },
        { name: 'money saved for emergencies' },
        { name: 'recreation that costs money' },
        { name: 'clothes to replace ones that are worn out' },
        { name: 'telephone or cell phone' },
        { name: 'vehicle that looks good' },
        { name: 'money for charity' },
        { name: 'regular medical checkups' },
        { name: 'paying current bills' },
        { name: 'vehicle insurance' },
        { name: 'clothes to keep up with current styles' },
        { name: 'vehicle that runs' },
        { name: 'money for gifts' },
        { name: 'a pet' },
        { name: 'paying past due bills' },
        { name: 'renter’s insurance' },
        { name: 'daycare/babysitting' },
      ],
      needs: <CardItem[]>[],
      wants: <CardItem[]>[],
    },
  };

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  setFlag() {
    this.flag = true;
  }

  resetFlag() {
    this.flag = false;
  }

  activityOneCompleted() {
    if (!this.delay) return true;

    if (this.model.cards.pool.length > 0) {
      return false;
    }

    const list = this.model.priorityList as any;

    if (Object.values(list).some((item: any) => !item.value)) {
      return false;
    }

    return true;
  }

  drop(event: CdkDragDrop<any>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  addCard() {
    this.model.cards.pool.push({ name: '', added: true, editing: true });
  }
}
